import { cn } from '../../lib/utils';

interface HubspotDappIconProps {
  iconUrl: string | null;
  name: string;
  className?: string;
}

export function HubspotDappIcon({
  iconUrl,
  name,
  className,
}: HubspotDappIconProps) {
  const baseClassName = cn(
    'size-10 shrink-0 rounded-lg border border-neutral-700/50 bg-neutral-800',
    className,
  );

  if (iconUrl) {
    return (
      <img
        src={iconUrl}
        alt={`${name} icon`}
        loading="lazy"
        className={cn(baseClassName, 'object-cover')}
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      className={cn(
        baseClassName,
        'flex items-center justify-center text-sm font-semibold text-neutral-500',
      )}
    >
      {name.trim().charAt(0).toUpperCase() || '?'}
    </div>
  );
}
